import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../interceptors/authentication.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent implements OnInit {

  constructor(private authService: AuthenticationService,
    private location: Location  ) { }

  ngOnInit(): void {
  }

  logout() {
    this.authService.logout();
  }

  back(): void {
    this.location.back();
  }

}
